import { create } from 'zustand';
import { InAppNotification, NotificationStats, NotificationFilters } from '../types';

interface InAppNotificationState {
    notifications: InAppNotification[];
    stats: NotificationStats | null;
    filters: NotificationFilters;
    isLoading: boolean;
    error: string | null;
    currentPage: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
    setNotifications: (n: InAppNotification[]) => void;
    setStats: (s: NotificationStats) => void;
    setFilters: (f: NotificationFilters) => void;
    setLoading: (v: boolean) => void;
    setError: (e: string | null) => void;
    setCurrentPage: (p: number) => void;
    setPageSize: (s: number) => void;
    setPaginationInfo: (total: number, pages: number) => void;
    markAsRead: (id: number) => void;
    reset: () => void;
}

const initial = {
    notifications: [] as InAppNotification[],
    stats: null as NotificationStats | null,
    filters: {} as NotificationFilters,
    isLoading: false,
    error: null as string | null,
    currentPage: 0,
    pageSize: 20,
    totalElements: 0,
    totalPages: 0,
};

export const useInAppNotificationStore = create<InAppNotificationState>((set) => ({
    ...initial,
    setNotifications: (notifications) => set({ notifications }),
    setStats: (stats) => set({ stats }),
    setFilters: (filters) => set({ filters }),
    setLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),
    setCurrentPage: (currentPage) => set({ currentPage }),
    setPageSize: (pageSize) => set({ pageSize }),
    setPaginationInfo: (totalElements, totalPages) => set({ totalElements, totalPages }),
    markAsRead: (id) => set((state) => ({
        notifications: state.notifications.map((n) =>
            n.id === id ? { ...n, read: true, readAt: new Date().toISOString() } : n
        ),
        stats: state.stats ? { ...state.stats, unreadCount: Math.max(0, state.stats.unreadCount - 1) } : state.stats,
    })),
    reset: () => set(initial),
}));
